import React from 'react';
import './footer.css';
import {FaLinkedin} from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="footer">
            <a href="https://www.linkedin.com/in/mehdi-benhariz" target="_blank" rel="noopener noreferrer">
            <p>Created by Mehdi Ben Hariz</p>
            <FaLinkedin/>
            </a>
        </footer>
    );
};

export default Footer;